<form [formGroup]="form">
    <div class="row mb-3">
        <div class="col-12">
            <div class="bg-card shadow-md rounded p-1">
                <div class="row" [dir]="languageService.direction()">
                    <div
                        class="col-sm-12 col-xs-12"
                        [class.col-md-4]="showEntityTypeAndSize()"
                        [class.col-md-12]="!showEntityTypeAndSize()"
                        [dir]="languageService.direction()"
                    >
                        <adaa-form-dropdown-tree
                            controlName="period"
                            formControlName="period"
                            [label]="'landingPage.entity_page.select_period' | translate"
                            [options]="periodOptions()"
                            (inputChanges)="onFilterChange()"
                        />
                    </div>
                    @if (showEntityTypeAndSize()) {
                        <div class="col-md-4 col-sm-12 col-xs-12" [dir]="languageService.direction()">
                            <adaa-form-dropdown
                                controlName="entityType"
                                formControlName="entityType"
                                [label]="'entity.create.entity_type' | translate"
                                [options]="entityTypesOptions()"
                                (inputChanges)="onFilterChange()"
                            />
                        </div>
                        <div class="col-md-4 col-sm-12 col-xs-12" [dir]="languageService.direction()">
                            <adaa-form-dropdown
                                controlName="entitySize"
                                formControlName="entitySize"
                                [label]="'entity.create.entity_size' | translate"
                                [options]="entitySizesOptions()"
                                (inputChanges)="onFilterChange()"
                            />
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</form>
